import type React from "react";
import { SiCoursera } from "react-icons/si";
import { Link } from "react-router-dom";
import styles from "./EnrolledClasses.module.scss";

type Course = {
	_id: string;
	name: string;
};

type Props = {
	classes: Course[];
};

const EnrolledClasses: React.FC<Props> = ({ classes }) => {
	return (
		<div className={styles.classesContainer}>
			<div className={styles.classesHeader}>
				<SiCoursera />
				<h2>Enrolled Classes</h2>
			</div>
			<ul>
				{classes.map((course: Course) => (
					<Link to={`/courses/${course._id}`} key={course._id}>
						<li key={course._id}>{course.name}</li>
					</Link>
				))}
			</ul>
		</div>
	);
};

export default EnrolledClasses;
